/* Milagron: ürün metafield'ındaki beden tablosu (custom.beden_tablosu) varsa getSizeChart yanıtı onunla değiştirilir.
   Yoksa istek olduğu gibi efx-mila uygulamasına gider. */
(function(){
  if(!window.__mlgSizeChart||window.__mlgSizeChartPatched)return;
  window.__mlgSizeChartPatched=true;
  var orig=window.fetch;
  window.fetch=function(input,init){
    try{
      var url=typeof input==='string'?input:(input&&input.url)||'';
      if(url.indexOf('/apps/efx-mila')!==-1&&init&&typeof init.body==='string'){
        var b=JSON.parse(init.body);
        if(b&&b.action==='getSizeChart'){
          return Promise.resolve(new Response(JSON.stringify({ok:true,hasSizeChart:true,sizeChart:{type:'html',htmlContent:window.__mlgSizeChart}}),{status:200,headers:{'Content-Type':'application/json'}}));
        }
      }
    }catch(e){}
    return orig.apply(this,arguments);
  };
})();
